// extracted by mini-css-extract-plugin
module.exports = {"gallerySlick":"style_gallerySlick__18sf2","slick-center":"style_slick-center__1GQwG","imgCard":"style_imgCard__3beB1","img":"style_img__319v_"};